export default "__VITE_ASSET__BHOPIvVB__"